import React from 'react';
import { useIntl } from 'react-intl';
import Typography from '@mui/material/Typography';

const EmptyInfiniteListComponent = function EmptyInfiniteListComponent() {
  const intl = useIntl();
  return (
    <Typography
      variant="body1"
      sx={{
        p: '16px',
      }}
    >
      {intl.messages.NO_ITEMS}
    </Typography>
  );
};

export default EmptyInfiniteListComponent;
